import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '../icon';

// styles
import css from './popup.sss';

// images
import CrossIconSvg from './images/cross.icon.svg';


export const Popup = ({ onClose, children, dataQa, dataCancelQa }) => (
    <div className={css.root} data-qaid={dataQa}>
        <span className={css.overlay} onClick={onClose} data-qaid={dataCancelQa} />
        <div className={css.container}>
            {children}
            <span
                className={css.close}
                onClick={onClose}
                data-qaid={dataCancelQa}
            >
                <Icon glyph={CrossIconSvg} />
            </span>
        </div>
    </div>
);

Popup.propTypes = {
    onClose: PropTypes.func,
    dataQa: PropTypes.string,
    dataCancelQa: PropTypes.string,
};
